<template>
  <div>
  <a-table
      bordered
      :columns="columns"
      :data-source="dataList"
      :pagination="false"
      :loading="loading"
      size="small"
  >
      <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'config_status'">
              {{ text === 0 ? getLanguage('离线') : '' }}
              {{ text === 1 ? getLanguage('在线') : '' }}
          </template>
          <template v-if="column.dataIndex === 'delay'">
            {{ !text ? getLanguage('正常') : getLanguage('延迟') }}
          </template>
      </template>
  </a-table>
  
  </div>

</template>

<script lang="ts" setup>
import request from "../../common/request";
import { useRouter } from "vue-router";
import { computed, onMounted } from "vue";
import { ref, reactive, watch } from "vue";
import type { UploadProps } from "ant-design-vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
const router = useRouter();
const loading = ref(false);
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
import { getLanguage } from "@/common/translate";
operateLogs("Access edge gateway management");
/**操作日志记录 */

let dataList:any = ref([])
const columns = [
{
  title: getLanguage("数采器编码"),
  dataIndex: "config_code",
  align: "center",
},
{
  title: getLanguage("关联设备"), 
  dataIndex: "device_name",
  align: "center",
},
{
  title: getLanguage("数采器类型"), 
  dataIndex: "config_type_name",
  align: "center",
},
{
  title: getLanguage("数采器状态"), 
  dataIndex: "config_status",
  align: "center",
},
{
  title: getLanguage("数据延时"),
  dataIndex: "delay",
  align: "center",
},
// {
//   title: getLanguage("最后通讯时间"),
//   dataIndex: "config_last_online",
//   align: "center",
// },
// {
//   title: getLanguage("MAC"),
//   dataIndex: "config_desc",
//   align: "center",
// },
];

onMounted(() => {
  init()
})

const init = () => {
  getData()
}

const getData = async () => {
let config: any = {
      params: {
        factoryId:localStorage.getItem("factory_id"),
        take: 2000,
      },
      headers: {
          requestId: uuidv4(),
      },
  };
  let result = await request.get('/api/external/hardware/das/list',config)
  
  dataList.value = result.data.list || []
  console.log('dataList.value', dataList.value)
}


</script>

<style scoped>
.greenpoint {
width: 14px;
height: 14px;
border-radius: 50%;
background-color: green;
display: inline-block;
position: relative;
top: 2px;
margin-right: 5px;
}

.redpoint {
width: 14px;
height: 14px;
border-radius: 50%;
background-color: red;
display: inline-block;
position: relative;
top: 2px;
margin-right: 5px;
}

.spanbtn {
margin-top: 10px;
}

.code-box {
position: relative;
display: inline-block;
width: 90%;
margin: 0 0px 16px;
border: 1px solid #f0f0f0;
border-radius: 2px;
transition: all 0.2s;
padding: 15px;
}

.main {
margin-top: 30px;
}
</style>